import { render, staticRenderFns } from "./BankAccount.vue?vue&type=template&id=7290e394&scoped=true&lang=pug&"
import script from "./BankAccount.vue?vue&type=script&lang=js&"
export * from "./BankAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7290e394",
  null
  
)

export default component.exports